import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  stepIcon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.spacing(5)}px;
    height: ${theme.spacing(5)}px;
    border-radius: 50%;
    background-color: ${theme.go.schemes.colors.system.BgMinor};
  `,
}
